export const SET_SERVICE_PRICES = 'SET_SERVICE_PRICES'
export const API_SERVICES_FETCH_ALL_START = 'API_SERVICES_FETCH_ALL_START'
export const API_SERVICES_FETCH_ALL_SUCCESS = 'API_SERVICES_FETCH_ALL_SUCCESS'
export const API_SERVICES_FETCH_ALL_FAILURE = 'API_SERVICES_FETCH_ALL_FAILURE'
